<template>
  <div class='qrcode-error-container'>
    <span>{{errMsg}}</span>
    <button @click="handle">去主页看看</button>
  </div>
</template>

<script>

export default {
  name: 'QrcodeError',
  data() {
    return {
      errMsg: ''
    }
  },
  created() {
    this.errMsg = this.$route.params.errMsg
    this.errMsg = '谢谢惠顾'
  },
  computed: {
  },
  methods: {
    handle() {
      this.$router.replace({ name: 'Index' })
    }
  }
}
</script>

<style lang="scss" scoped>
.qrcode-error-container {
  margin: 250px 0;
  text-align: center;

  span {
    width: 300px;
    font-size: 16px;
    color: #4a4a4a;
    font-weight: 600;
    display: block;
    margin:0 auto;
  }
  p {
    color: #747474;
    font-size: 14px;
    font-weight: 400;
  }
  button {
    margin-top: 24px;
    width: 120px;
    height: 30px;
    border-radius: 15px;
    background-color: #5e5ef6;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    border: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/qrcode/error.vue